import type { TablesItemProps } from '../../../../user/Records/components/TablesItem.tsx';
import { TablesItem } from '../../../../user/Records/components/TablesItem.tsx';
import { get, useFormContext } from 'react-hook-form';
import { memo } from 'react';
import type { FormItemDefinition } from '../../../../../types';

export type TablesItemEditableProps = {
  id: string;
  definition?: FormItemDefinition;
  agendaId?: string;
} & TablesItemProps;

const TablesItemEditableBase = (props: TablesItemEditableProps) => {
  const {
    formState: { errors },
  } = useFormContext();

  return (
    <TablesItem
      agendaId={props.agendaId}
      error={get(errors, props.id)}
      detail={false}
      valueOptions={{ shouldDirty: true, shouldTouch: true }}
      {...props}
    />
  );
};

export const TablesItemEditable = memo(TablesItemEditableBase) as typeof TablesItemEditableBase;
